import { Box, TextWithTooltip } from "@hightouch/htui";

import { useNavWidth } from "src/contexts/nav-width-context";

export type Props = {
  children: string;
};

export const NavItemText = ({ children }: Props) => {
  const { isNavOpen } = useNavWidth();

  if (!isNavOpen) {
    return null;
  }

  return (
    // Marks the label, so a row can make room at its end for a control.
    <Box data-nav-label display="flex" flex={1} minWidth={0}>
      <TextWithTooltip
        color="inherit"
        size="md"
        fontWeight="medium"
        placement="right"
      >
        {children}
      </TextWithTooltip>
    </Box>
  );
};
